import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { DELETE_TRAINING_SAMPLE } from '../graphql/operations';
import { TrainingSample } from '../types';

export interface UseTrainingSampleDeleteReturn {
  deleteDialogOpen: boolean;
  selectedSample: TrainingSample | null;
  isDeleting: boolean;
  handleDeleteClick: (sample: TrainingSample, event: React.MouseEvent) => void;
  handleDeleteConfirm: () => void;
  handleDeleteCancel: () => void;
}

export const useTrainingSampleDelete = (onDeleteSuccess?: () => void): UseTrainingSampleDeleteReturn => {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedSample, setSelectedSample] = useState<TrainingSample | null>(null);

  const [deleteSample, { loading: isDeleting }] = useMutation(DELETE_TRAINING_SAMPLE, {
    onCompleted: () => {
      setDeleteDialogOpen(false);
      setSelectedSample(null);
      onDeleteSuccess?.();
    },
    onError: (error) => {
      console.error('Error deleting training sample:', error);
    }
  });

  const handleDeleteClick = (sample: TrainingSample, event: React.MouseEvent) => {
    event.stopPropagation();
    setSelectedSample(sample);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = () => {
    if (selectedSample) {
      deleteSample({ variables: { id: selectedSample.id } });
    }
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
    setSelectedSample(null);
  };

  return {
    deleteDialogOpen,
    selectedSample,
    isDeleting,
    handleDeleteClick,
    handleDeleteConfirm,
    handleDeleteCancel,
  };
};